<template>
  <v-row class="mb-4">
    <v-col cols="12" md="6">
      <v-card
        color="teal"
        class="pa-4 h-100"
        @click="$router.push('/my-msisdns')"
        style="cursor: pointer;"
      >
        <v-card-title class="text-white d-flex align-center">
          <v-icon class="mr-2" size="large">mdi-phone-plus</v-icon>
          {{ t.dashboard?.add_own_number || 'Add Own Number' }}
        </v-card-title>
        <v-card-subtitle class="text-white">
          {{ t.dashboard?.add_own_number_desc || 'Add a phone number to your account' }}
        </v-card-subtitle>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card
        color="indigo"
        class="pa-4 h-100"
        @click="$router.push('/my-msisdns')"
        style="cursor: pointer;"
      >
        <v-card-title class="text-white d-flex align-center">
          <v-icon class="mr-2" size="large">mdi-swap-horizontal</v-icon>
          {{ t.dashboard?.portability_request || 'Portability Request' }}
        </v-card-title>
        <v-card-subtitle class="text-white">
          {{ t.dashboard?.portability_request_desc || 'Initiate a number porting request' }}
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'

export default {
  name: 'AccountManagementSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  computed: {
    t() { return tRef.value }
  }
}
</script>
